<template>
    <v-app>
        <Toolbar title="Group Detail"/>
        <v-content>
            <v-layout row>
                <v-flex xs12 sm12 offset-sm0>
                    <v-card>
                        <v-card-title primary-title>
                            <v-btn @click="$router.push({path: '/groups'})">
                                <v-icon dark>arrow_back</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                            <div>
                                <div class="headline">{{ groupData['name'] }}</div>
                                <span class="grey--text">ID: {{ groupId }}</span>
                            </div>
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>

            <v-flex xs12 md10 offset-md1 v-if="userCanOrder">
                <v-toolbar color="blue darken-2" dark>
                    <v-toolbar-title></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="blue" @click="$router.push(orderLink)">List Group Orders</v-btn>
                </v-toolbar>
            </v-flex>

            <v-card>
                <v-card-title primary-title>
                    <h3 class="headline mb-0">Devices</h3>
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="deviceHeaders"
                        :items="dDataValue"
                        :search="search"
                        :rows-per-page-items="rowsPerPage"
                >
                    <template slot="items" slot-scope="props">
                        <td class="subheading" @click="routeLink(props.item.serial)">
                            {{ props.item.serial }}
                        </td>
                        <td class="subheading" @click="routeLink(props.item.serial)">{{
                            props.item['merchant.merchantid']
                            }}
                        </td>
                        <td class="subheading" @click="routeLink(props.item.serial)">{{
                            props.item['merchant.terminalid']
                            }}
                        </td>
                        <td class="subheading" @click="routeLink(props.item.serial)">{{ props.item['header.line1'] }}
                        </td>
                        <td class="subheading" @click="routeLink(props.item.serial)">{{ props.item['device.name'] }}
                        </td>
                        <td class="subheading" @click="routeLink(props.item.serial)">{{ props.item['version'] }}
                        </td>
                        <td class="subheading" @click="routeLink(props.item.serial)">{{ props.item['last_updated'] }}
                        </td>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                        Your search for "{{ search }}" found no results.
                    </v-alert>
                </v-data-table>
            </v-card>
            <v-layout row wrap>
                <GroupUsers :group="groupId" :users="groupData.users"/>
                <GroupRename :group="groupId"/>
            </v-layout>
        </v-content>
    </v-app>
</template>

<script>
    import {mapActions} from 'vuex'
    import Toolbar from '../components/Toolbar'
    import GroupUsers from '../components/GroupUsers'
    import GroupRename from '../components/GroupRename'

    const fb = require('../firebase')

    export default {
        name: "Group",
        components: {Toolbar, GroupUsers, GroupRename},
        data() {
            return {
                search: '',
                rowsPerPage: [25, 50, 100, {'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1}],
                deviceHeaders: [
                    {text: 'Serial', align: 'left', sortable: true, value: 'serial'},
                    {text: 'Merchant ID', align: 'left', sortable: true, value: 'merchant.merchantid'},
                    {text: 'Terminal ID', align: 'left', sortable: true, value: 'merchant.terminalid'},
                    {text: 'Business', align: 'left', sortable: true, value: 'header.line1'},
                    {text: 'Device Name', align: 'left', sortable: true, value: 'device.name'},
                    {text: 'Version', align: 'left', sortable: true, value: 'version'},
                    {text: 'Updated', align: 'left', sortable: true, value: 'last_updated'}
                ],
                renameDialog: false,
                renameGroupText: '',
                dData: []
            }
        },
        mounted() {
            // console.log(this.groupId)

            if (!this.isUserLoggedIn()) {
                this.$router.push({path: '/signin'})
            }
            if (this.groupId === undefined || this.groupId === 'undefined') {
                this.$router.push({path: '/groups'})
            }

            this.fetchAll()
            this.deviceData()
        },
        computed: {
            groupId: function () {
                return this.$route.params.id
            },
            groupData: function () {
                let gd = this.$store.state.groups[this.groupId]
                if (gd === undefined) {
                    return {}
                }
                return gd
            },
            orderLink: function () {
                return '/orders/' + this.groupId
            },
            userCanOrder: function () {
                if (this.$store.state.users[fb.auth.currentUser.uid] !== undefined) {
                    return this.$store.state.users[fb.auth.currentUser.uid].orders === true
                } else {
                    return false
                }
            },
            dDataValue: function () {
                return this.dData
            }
        },
        methods: {
            ...mapActions(['isUserLoggedIn', 'fetchAll']),
            routeLink: function (val) {
                this.$router.push('/device/' + this.groupId + '/' + val)
            },
            timeConverter: function (UNIX_timestamp) {
                let a = new Date(parseInt(UNIX_timestamp) * 1000);
                let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                let year = a.getFullYear();
                let month = months[a.getMonth()];
                let date = a.getDate();
                let hour = a.getHours();
                let min = a.getMinutes();
                let sec = a.getSeconds();

                if (month === undefined) {
                    return 'Never'
                }
                return date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec;
            },
            deviceData: async function () {
                let groupObject = this.$store.state.groups[this.groupId]

                let devices = []

                if (groupObject !== undefined) {
                    devices = Object.values(groupObject['devices'])
                }

                let output = []
                if (devices.length > 0) {
                    devices.forEach( (device) => {
                        let did = 'castles_' + device + '@kineticsmart.com'
                        let d = this.$store.state.devices[did]
                        d.id = did
                        d.serial = device

                        let status = this.$store.state.statuses[device]
                        if (status === undefined) {
                            d.last_updated = "Never"
                            d.version = "Unknown"
                        } else {
                            if (status['autoupdate.last_update'] === undefined) {
                                d.last_updated = "Never"
                            } else {
                                // console.log(status['autoupdate.last_update'])
                                d.last_updated =  this.timeConverter(status['autoupdate.last_update'])
                            }
                            d.version = status['version']
                        }

                        output.push(d)

                        if (output === undefined) {
                            output = []
                        }
                        this.dData = output

                    })
                }


            }
        }
    }
</script>

<style scoped>

</style>
